// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';

export const advisorRerunInClientOneMax = 120;

export const advisorRerunInCountryOneMax = 6;

export const advisorRerunInCrmReferenceOneMax = 120;

export const advisorRerunInFileIdsOneMax = 10;

export const advisorRerunInProblemOneMax = 8000;

export const AdvisorRerunIn = zod.object({
  "client": zod.union([zod.string().min(1).max(advisorRerunInClientOneMax),zod.null()]).optional(),
  "country": zod.union([zod.string().max(advisorRerunInCountryOneMax),zod.null()]).optional(),
  "crm_reference": zod.union([zod.string().max(advisorRerunInCrmReferenceOneMax),zod.null()]).optional(),
  "file_ids": zod.union([zod.array(zod.uuid()).max(advisorRerunInFileIdsOneMax),zod.null()]).optional(),
  "idea_id": zod.union([zod.uuid(),zod.null()]).optional(),
  "industry_id": zod.union([zod.uuid(),zod.null()]).optional(),
  "problem": zod.union([zod.string().min(1).max(advisorRerunInProblemOneMax),zod.null()]).optional()
});

export type AdvisorRerunIn = zod.input<typeof AdvisorRerunIn>;
export type AdvisorRerunInOutput = zod.output<typeof AdvisorRerunIn>;
